import * as loadImage from "blueimp-load-image"

export async function fixRotation(file, mediaType = "image") {
  // We do not rotate videos.
  if (mediaType !== "image") return file

  return new Promise((resolve) => {
    loadImage(
      file,
      (img) => {
        img.toBlob((blob) => {
          // Ensure the returned blob is a File with a name
          if (blob) {
            const fixedFile = new File([blob], file.name || 'upload.jpg', {
              type: blob.type || 'image/jpeg',
              lastModified: Date.now()
            })
            resolve(fixedFile)
          } else {
            resolve(file)
          }
        }, "image/jpeg")
      },
      {
        canvas: true,
        orientation: true
      }
    )
  })
}
